import "./StandUpScheduleCardComponent.scss";

import { Flex, Image, Segment, Text } from "@fluentui/react-northstar";
import { scheduleDTOtoDetailsBarInfo, scheduleDetailsBarText } from "@teams/cards";
import { ScheduleDTO, UserDTO } from "@teams/types/api";
import moment from "moment";
import React, { CSSProperties } from "react";

import AgilePendingImage from "../../../../_shared/assets/agile-pending-image.svg";
import CorePendingImage from "../../../../_shared/assets/core-pending-image.svg";
import { HeroUnit } from "../../../../_shared/components/HeroUnit";
import { SeriesMenu } from "../../../../_shared/components/Menus/SeriesMenu/SeriesMenu";
import { PollyIcon } from "../../../../_shared/components/PollyIcon";
import { AgileHeaderComponent } from "../../components/AgileHeader/AgileHeaderComponent";

interface StandUpScheduleCardComponentProps {
  schedule: ScheduleDTO;
  user: UserDTO;
  onChanged: (seriesId: string) => void;
}
export const StandUpScheduleCard: React.FC<StandUpScheduleCardComponentProps> = ({
  schedule,
  user,
  onChanged,
}) => {
  const PendingImage =
    schedule.applicationType === "msteams" ? CorePendingImage : AgilePendingImage;
  const appHeroUnitStyles =
    schedule.applicationType === "msteams" ? coreHeroUnitStyles : agileHeroUnitStyles;

  return (
    <Segment color="brand" className="standup-schedule-card">
      {(schedule.applicationType === "msteams" || !schedule.lastSurvey) && (
        <div className="standup-schedule-card__spacer"></div>
      )}
      <AgileHeaderComponent
        title={schedule.template?.title || schedule.name}
        detailsBarText={scheduleDetailsBarText(scheduleDTOtoDetailsBarInfo(schedule), {
          activeCardDateFormat: false,
        })}
      />
      <HeroUnit style={appHeroUnitStyles}>
        {schedule.state === "active" && (
          <Text align="center" weight="light" color="gray">{`🕘 Starts: ${moment(
            schedule.next
          ).format("MMM Do [at] LT")}`}</Text>
        )}
        <Image src={PendingImage} alt="Stand Up" />
      </HeroUnit>
      <Flex vAlign="center">
        <Flex.Item grow>
          <div className="standup-card__autolink">
            {schedule.autolinkIntegrations && schedule.autolinkIntegrations.length > 0 && (
              <PollyIcon
                icon="integration-icon"
                label={`Integrations (${schedule.autolinkIntegrations.length})`}
                inheritColor
              />
            )}
          </div>
        </Flex.Item>
        <SeriesMenu user={user} schedule={schedule} onChanged={() => onChanged(schedule.id)} />
      </Flex>
      <div className="standup-schedule-card__gap"></div>
    </Segment>
  );
};

const agileHeroUnitStyles: CSSProperties = {
  margin: "0px",
  padding: 20,
  minHeight: 200,
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
};

const coreHeroUnitStyles: CSSProperties = {
  ...agileHeroUnitStyles,
  minHeight: 268,
};
